import { ControlledSelect } from 'modules/common/components';
import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { donorStatuses } from './options';

type PropTypes = Omit<ComponentProps<typeof ControlledSelect>, 'options'>;

const AnticoagulantSelect: FC<PropTypes> = (props) => {
  const { t } = useTranslation('products.AnticoagulantSelect');

  return (
    <ControlledSelect
      options={donorStatuses}
      placeholder={t('selectAnticoagulant')}
      {...props}
    />
  );
};

export default AnticoagulantSelect;
